import TemaComunicacionService from 'src/modules/temaComunicacion/temaComunicacionService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'TEMACOMUNICACION_VIEW';

const temaComunicacionViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: temaComunicacionViewActions.FIND_STARTED,
      });

      const record = await TemaComunicacionService.find(id);

      dispatch({
        type: temaComunicacionViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: temaComunicacionViewActions.FIND_ERROR,
      });

      getHistory().push('/tema-comunicacion');
    }
  },
};

export default temaComunicacionViewActions;
